
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../services/login.service'; // Passe Pfad an

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  form: FormGroup;
  loading = false;
  error: string | null = null;

  constructor(private fb: FormBuilder, private auth: LoginService, private router: Router,  private route: ActivatedRoute, private location: Location) {
    this.form = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      remember: [false]
    });


  }
reloadRoute() {
  const currentUrl = this.router.url.split('?')[0] === '/login' ? '/home' : this.router.url;
  this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    this.router.navigate([currentUrl]);
  });
}
  submit() {
    if (this.form.invalid) return;
    this.loading = true;
    this.error = null;

    const { username, password } = this.form.value;
    this.auth.login(username!, password!).subscribe(
      success => {
        this.loading = false;
        if (success) {
          if (this.form.value.remember) {
            const header = this.auth.getAuthHeader();
            //const userId = this.auth.getUserId();
            if (header) localStorage.setItem('basic_auth_header_persistent', header);
          } else {
            localStorage.removeItem('basic_auth_header_persistent');
          }
          console.log("Anmeldung ok")
          //this.router.navigate([this.location.path()]);
          this.reloadRoute();
        } else {
          this.error = 'Ungültige Anmeldedaten';
        }
      },
      () => {
        this.loading = false;
        this.error = 'Fehler beim Anmelden';
      }
    );
  }
}
